// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__ySu1n","upload":"Small_upload__2PCG4","imageWrap":"Small_imageWrap__34U9D","removeBtn":"Small_removeBtn__1_ZPU"};